export { Image as RemoteSvg } from './Image.web'
